module.exports = __webpack_public_path__ + "img/ico-phone.0eb04084.svg";